import {
  LIST_LOCATIONS,
  LIST_LOCATIONS_SUCCESS,
  LIST_LOCATIONS_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  locations: [],
}

const LocationsList = (state = initialState, action) => {
  switch (action.type) {
    case LIST_LOCATIONS:
      state = {
        ...state,
        loading: true,
      }
      break
    case LIST_LOCATIONS_SUCCESS:
      state = {
        ...state,
        locations: action.payload.locations,
        loading: false,
        done: true,
      }
      break
    case LIST_LOCATIONS_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default LocationsList
